module.exports = __webpack_public_path__ + "img/reliable-2.ce7579e4.png";